module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/mv_02-e34bf62b774ad2c5d9b84787c08eed3b.jpg";